

















import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { MESSAGE, Mutations } from '@/store/types';

const messages = namespace(MESSAGE);

@Component
export default class MessageBar extends Vue {
  @messages.State('message')
  public message: string;
  @messages.State('title')
  public title: string;
  @messages.State('connectionIssue')
  public connectionIssue: boolean;
  public classes: string = '';

  @Watch('message')
  public onMessageChange(newVal: string, oldVal: string) {
    if (newVal) {
      const alreadyChanged = this.classes.includes('hd-err-change-1');
      this.classes = 'hd-err-shown';
      if (oldVal) {
        this.classes += (alreadyChanged ? ' hd-err-change-2' : ' hd-err-change-1');
      }
    } else {
      this.classes = '';
    }
  }

  public dismiss() {
    this.$store.commit(Mutations.Message.resetMessage);
  }
}
